var map = {
	"./12_brown.mp3": "d7624",
	"./13_grey.mp3": "00c5",
	"./50_dog.mp3": "0008",
	"./51_cat.mp3": "df38",
	"./52_mouse.mp3": "a66e",
	"./53_fish.mp3": "9840",
	"./9_yellow.mp3": "4cb2",
	"./M_Brilliant.mp3": "8ecb",
	"./M_Excellent.mp3": "8b6f",
	"./M_Fantastic.mp3": "a0a1",
	"./M_Great.mp3": "da35",
	"./M_Perfect.mp3": "469b",
	"./M_Think again.mp3": "73ac",
	"./M_Try again.mp3": "1885",
	"./M_Very good.mp3": "63ee",
	"./M_Well done.mp3": "c1da",
	"./M_Work harder.mp3": "1604",
	"./click.mp3": "9a6e",
	"./false.mp3": "6efb",
	"./true.mp3": "9b6b",
	"./white.mp3": "ca628"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4156";